// Compact follower count: 0-999 exact, 1K-999.9K, 1M+ (one decimal, never
// rounded UP into the next unit: 999 999 -> "999.9K", not "1000K"/"1M").
const ONE_DECIMAL_DOWN = (value) => Math.floor(value * 10) / 10;
const trim = (value) => String(value).replace(/\.0$/, "");

export const formatFollowersCount = (count) => {
  const n = Math.max(0, Math.floor(Number(count) || 0));
  if (n < 1000) return String(n);
  if (n < 1000000) return `${trim(ONE_DECIMAL_DOWN(n / 1000))}K`;
  return `${trim(ONE_DECIMAL_DOWN(n / 1000000))}M`;
};

export default formatFollowersCount;
